/**
 * Deadline for background/reference GETs (PERF-API-01 B02).
 *
 * A read that never settles is worse than one that fails: the failure is
 * retried on the next cycle, the hang is not. Every coalesced reader in the
 * shell — the polling hook's single-flight guard, the badge thunk's
 * `condition` latch, the shared branch in-flight promise — keeps exactly one
 * slot open per scope, and a socket that hangs without an OS/proxy reset holds
 * that slot for the life of the page.
 *
 * 30s matches the bound already carried by the job-card read
 * (`jobCardSlice.js` `fetchJobCard`), so this introduces no new number: it
 * applies the existing precedent to the reads that were missing it.
 *
 * DELIBERATELY READS ONLY. Writes, payments and provider calls are NOT bounded
 * here and `axios.defaults.timeout` is left unset — a POST cut off at 30s may
 * well have been applied server-side, and the client cannot know. Callers that
 * need a longer read (AI, damage scan) keep their own explicit timeout.
 */
export const BACKGROUND_READ_TIMEOUT_MS = 30000;

export default BACKGROUND_READ_TIMEOUT_MS;
